import { render, staticRenderFns } from "./ViewAddresses.vue?vue&type=template&id=665221f3"
import script from "./ViewAddresses.vue?vue&type=script&lang=js"
export * from "./ViewAddresses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports